import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { formatRoute } from "react-router-named-routes"
import routes from "../../routes"
import "./CaseListCard.scss"

const CaseListCard = (props) => {
  const allPath =
    props.listType === "open" ? routes.openCases : routes.archivedCases
  let cases
  if (props.loading) {
    cases = Array(5).fill(null)
  } else {
    cases = props.cases.slice(0, 5) // We only want to display 5 max.
  }
  return (
    <div className="CaseListCard">
      <div className="header">
        {`${props.listType.charAt(0).toUpperCase()}${props.listType.slice(1)}`}{" "}
        Cases
      </div>
      <div className="body">
        {cases.length > 0 && (
          <ol>
            {cases.map((kase, i) => (
              <li
                key={kase?.internalId || i}
                className={props.loading ? "loading" : ""}
              >
                <Link
                  to={formatRoute(routes.caseDetail, {
                    facilityId: props.facilityId,
                    caseId: kase?.internalId,
                  })}
                >
                  <span className="listIndex">{i + 1}</span>
                  <span className="name">{kase?.name}</span>
                  <div>
                    <span className="id">#{kase?.internalId}</span>
                    <i className="fa fa-angle-right" />
                  </div>
                </Link>
              </li>
            ))}
          </ol>
        )}
        {!props.loading && cases.length === 0 && (
          <div className="empty">No {props.listType} cases found.</div>
        )}
      </div>
      <div className="footer">
        {cases.length > 0 && (
          <Link to={formatRoute(allPath, { facilityId: props.facilityId })}>
            View {props.caseCount} {props.listType} cases{" "}
            <i className="fa fa-angle-right" />
          </Link>
        )}
      </div>
    </div>
  )
}

CaseListCard.defaultProps = {
  listType: "open",
  cases: [],
  loading: false,
}

CaseListCard.propTypes = {
  listType: PropTypes.oneOf(["open", "archived"]).isRequired,
  cases: PropTypes.arrayOf(
    PropTypes.shape({
      internalId: PropTypes.string,
      name: PropTypes.string,
    })
  ).isRequired,
  caseCount: PropTypes.number,
  facilityId: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
}

export default CaseListCard
